var map = {
	"./angle-down.svg": 1089,
	"./arrow-down.svg": 1090,
	"./arrow-triangle-fill-down.svg": 1091,
	"./arrow-triangle-fill-up.svg": 1092,
	"./bar-line.svg": 581,
	"./check.svg": 1093,
	"./clock.svg": 547,
	"./cross.svg": 1094,
	"./download-line.svg": 582,
	"./email-line.svg": 1095,
	"./file-line.svg": 1096,
	"./filter.svg": 1097,
	"./folder.svg": 546,
	"./folder2.svg": 1098,
	"./garph-line.svg": 583,
	"./image.svg": 1099,
	"./pdf.svg": 1100,
	"./printer-line.svg": 1101,
	"./push-icon.svg": 219,
	"./report-line.svg": 1102,
	"./sort-arrow-down.svg": 213,
	"./sort-arrow-up.svg": 214,
	"./star.svg": 1103,
	"./trash.svg": 1104,
	"./triangle-fill-down.svg": 1105,
	"./updated-file.svg": 192,
	"./upload-img.svg": 584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1088;